/* AppRequestStatusTooltipV2.tsx generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _7 = "._k48pni7l{font-weight:600}";
const _6 = "._syaz1k3w{color:var(--ds-text-subtle)}";
const _5 = "._19pkidpf{margin-top:0}";
const _4 = "._2hwxh461{margin-right:var(--ds-space-050)}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1e0c1txw{display:flex}";
import CheckCircleOutlineIcon from '@atlaskit/icon/glyph/check-circle-outline';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { RequestStatus } from '@atlassian/mpac-api-client';
import { BodyNormal, BodySmall } from '@atlassian/mpac-primitives';
import { RichTooltip } from '@atlassian/mpac-ui';
import { DateUtils } from '@atlassian/mpac-utils';
import React from 'react';
const _ = "._p12f10yc{max-width:12.8125rem}";
const TooltipContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_p12f10yc", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  TooltipContainer.displayName = 'TooltipContainer';
}
const Container = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_2, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _4cvr1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const IconWrapper = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_4, _2, _3]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_2hwxh461 _1e0c1txw _4cvr1h6o", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  IconWrapper.displayName = 'IconWrapper';
}
const Content = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_5, _6]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pkidpf _syaz1k3w", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Content.displayName = 'Content';
}
const TooltipRejectedTitle = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_k48pni7l", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  TooltipRejectedTitle.displayName = 'TooltipRejectedTitle';
}
export const AppRequestStatusTooltipV2 = props => {
  let label;
  let icon;
  let tooltipContent;
  const response = props.appRequestStatus;
  if (response.status === RequestStatus.OPEN) {
    label = 'App requested';
    icon = /*#__PURE__*/React.createElement(CheckCircleOutlineIcon, {
      label: "",
      size: "small",
      primaryColor: "var(--ds-icon)"
    });
    tooltipContent = /*#__PURE__*/React.createElement(TooltipContainer, null, /*#__PURE__*/React.createElement(BodySmall, null, "You requested for the app on ", DateUtils.longDate(response.requestedDate, 'MMM dd, yyyy')));
  } else if (response.status === RequestStatus.REJECTED) {
    label = 'App request rejected';
    icon = /*#__PURE__*/React.createElement(WarningIcon, {
      size: "small",
      label: ""
    });
    tooltipContent = /*#__PURE__*/React.createElement(TooltipContainer, null, /*#__PURE__*/React.createElement(TooltipRejectedTitle, null, "Reason for rejection as on ", DateUtils.longDate(response.rejectedDate, 'MMM dd, yyyy'), ":"), /*#__PURE__*/React.createElement(BodySmall, null, "\"".concat(response.rejectComment, "\"")));
  }
  return /*#__PURE__*/React.createElement(RichTooltip, {
    content: tooltipContent
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(IconWrapper, null, icon), /*#__PURE__*/React.createElement(Content, null, label)));
};